import {all, call, fork, put, takeEvery} from 'redux-saga/effects'
import {
  HyperLinkMenusActionTypes, deleteError, deleteSuccess, fetchError, fetchSuccess, createError, createSuccess,
  updateSuccess, updateError, fetchItemSuccess, fetchItemError
} from '@actions/hyperLinkMenu';
import {updateSuccess as updateCurrentHyperLinkMenu} from '@actions/auth';
import hyperLinkMenuApi from '@api/hyperLinkMenu';
import {ReduxAction} from "@actions/index";


function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(hyperLinkMenuApi.getList, payload);
    yield put(fetchSuccess(res))
  } catch (err) {
    yield put(fetchError(err))
  }
}


function* handleDelete({payload}: ReduxAction) {
  try {
    yield call(hyperLinkMenuApi.delete, payload);
    yield put(deleteSuccess(payload.params));
  } catch (err) {
    yield put(deleteError(err))
  }
}


function* handleCreate({payload}: ReduxAction) {
  try {
    const {data} = yield call(hyperLinkMenuApi.create, payload);
    payload.onSuccessCallback && payload.onSuccessCallback(data);
    yield put(createSuccess(data))
  } catch (err) {
    yield put(createError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(hyperLinkMenuApi.update, payload);
    payload.onSuccessCallback && payload.onSuccessCallback();
    yield put(updateSuccess(data));
    // For updating current hyperLinkMenu info in header :
    yield put(updateCurrentHyperLinkMenu(data));
  } catch (err) {
    yield put(updateError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


// We can also use `fork()` here to split our saga into multiple watchers.
function* hyperLinkMenusSaga() {
  yield all([
    yield takeEvery(HyperLinkMenusActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(HyperLinkMenusActionTypes.DELETE_REQUEST, handleDelete),
    yield takeEvery(HyperLinkMenusActionTypes.CREATE_REQUEST, handleCreate),
    yield takeEvery(HyperLinkMenusActionTypes.UPDATE_REQUEST, handleUpdate),
  ])
}

export default hyperLinkMenusSaga
